<template>
  <v-app>
    <v-app-bar app height="48" elevation="1" v-if="getAuth">
      <img :src="require('@/assets/logo.png')" height="30" style="vertical-align: middle; padding-right: 15px" v-if="!mobile" />
      <img :src="require('@/assets/logo_mobile.png')" height="30" style="vertical-align: middle; padding-right: 15px" v-else />
      <h4>
        {{ tituloPagina }}
      </h4>
      <v-spacer></v-spacer>
      <span class="pr-2 hidden-sm-and-down" v-if="getInfo">{{ getInfo.full_name }}</span>
      <v-menu transition="slide-y-transition" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <img
            :src="getFotoUsuarioLogado"
            alt="foto"
            class="rounded-circle user-button"
            width="40px"
            v-bind="attrs"
            v-on="on"
            v-if="!!getFotoUsuarioLogado"
          />
          <v-avatar color="primary" size="36" v-bind="attrs" v-on="on" v-else
            ><span class="white--text text-h6">{{ getLetraNome }}</span></v-avatar
          >
        </template>
        <v-list>
          <v-list-item v-if="isAdmin">
            <v-list-item-title>
              <v-btn @click="goTo('PainelLeiloeiro')" text> <v-icon icon>mdi-gavel</v-icon>&nbsp;Painel do Leiloeiro </v-btn>
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-if="isAdmin">
            <v-list-item-title>
              <v-btn @click="goTo('PainelComitente')" text> <v-icon icon>mdi-office-building</v-icon>&nbsp;Painel do Comitente </v-btn>
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-if="isAdmin">
            <v-list-item-title>
              <v-btn @click="goTo('PainelYoutube')" text> <v-icon icon>mdi-youtube</v-icon>&nbsp;Painel do Youtube </v-btn>
            </v-list-item-title>
          </v-list-item>
          <v-divider v-if="isAdmin"></v-divider>
          <v-list-item>
            <v-list-item-title>
              <v-btn @click="logout" text> <v-icon icon>mdi-logout</v-icon>&nbsp;Sair </v-btn>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { ORIGINS_ALLOWED } from '@/config';
import jwt from 'jsonwebtoken';
export default {
  name: 'App',

  data: () => ({
    window: null,
    items: [{ title: 'Sair' }],
  }),
  computed: {
    ...mapState(['tituloPagina']),
    ...mapGetters(['getAuth', 'getInfo', 'getFotoUsuarioLogado']),
    getLetraNome() {
      return this.getInfo?.full_name?.charAt(0);
    },
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    isAdmin() {
      const tokenDecoded = jwt.decode(this.getAuth.access_token) || {};
      //console.log(tokenDecoded);
      if (tokenDecoded.role.includes('Master')) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    ...mapActions(['logout', 'gInfo']),
    ...mapMutations(['SET_AUTH', 'SET_LEILAO', 'SET_CLIENT_APP']),
    getTokenFromSite() {
      window.addEventListener(
        'message',
        async (event) => {
          if (ORIGINS_ALLOWED.includes(event.origin) && !!event.data.auth && !!event.data.auth.access_token) {
            this.SET_AUTH({ ...event.data.auth });
            this.SET_LEILAO({ id: event.data.leilaoId });
            this.$nextTick(() => {
              this.gInfo();
              this.SET_CLIENT_APP('siteebl');
              this.$router.push({ name: 'AuditorioVirtual' });
            });

            event.source.postMessage('Recebido', event.origin);
          }
          return;
        },
        false
      );
    },
    goTo(rota) {
      this.$router.push({ name: rota });
    },
  },
  created() {
    this.getTokenFromSite();
  },
};
</script>
<style>
.square.v-btn:not(.v-btn--round).v-size--small {
  min-width: 28px;
  padding: 0;
}

.row {
  margin: 0px !important;
}
</style>
